const currencyData = [
  { label: 'USD - United States Dollar', value: 'USD', symbol: '$' },

  { label: 'EUR - Euro (European Union)', value: 'EUR', symbol: '€' },
  { label: 'EUR - Euro (Germany)', value: 'EUR_DE', symbol: '€' },
  { label: 'EUR - Euro (France)', value: 'EUR_FR', symbol: '€' },
  { label: 'EUR - Euro (Italy)', value: 'EUR_IT', symbol: '€' },
  { label: 'EUR - Euro (Spain)', value: 'EUR_ES', symbol: '€' },
  { label: 'EUR - Euro (Netherlands)', value: 'EUR_NL', symbol: '€' },
  { label: 'EUR - Euro (Belgium)', value: 'EUR_BE', symbol: '€' },
  { label: 'EUR - Euro (Portugal)', value: 'EUR_PT', symbol: '€' },
  { label: 'EUR - Euro (Greece)', value: 'EUR_GR', symbol: '€' },
  { label: 'EUR - Euro (Austria)', value: 'EUR_AT', symbol: '€' },
  { label: 'EUR - Euro (Ireland)', value: 'EUR_IE', symbol: '€' },
  { label: 'EUR - Euro (Luxembourg)', value: 'EUR_LU', symbol: '€' },
  { label: 'EUR - Euro (Finland)', value: 'EUR_FI', symbol: '€' },
  { label: 'EUR - Euro (Slovakia)', value: 'EUR_SK', symbol: '€' },
  { label: 'EUR - Euro (Slovenia)', value: 'EUR_SI', symbol: '€' },
  { label: 'EUR - Euro (Estonia)', value: 'EUR_EE', symbol: '€' },
  { label: 'EUR - Euro (Latvia)', value: 'EUR_LV', symbol: '€' },
  { label: 'EUR - Euro (Lithuania)', value: 'EUR_LT', symbol: '€' },
  { label: 'EUR - Euro (Cyprus)', value: 'EUR_CY', symbol: '€' },
  { label: 'EUR - Euro (Malta)', value: 'EUR_MT', symbol: '€' },
  { label: 'GBP - British Pound', value: 'GBP', symbol: '£' },
  { label: 'JPY - Japanese Yen', value: 'JPY', symbol: '¥' },
  { label: 'CNY - Chinese Yuan', value: 'CNY', symbol: '¥' },
  { label: 'AUD - Australian Dollar', value: 'AUD', symbol: '$' },
  { label: 'CAD - Canadian Dollar', value: 'CAD', symbol: '$' },
  { label: 'CHF - Swiss Franc', value: 'CHF', symbol: 'CHF' },
  { label: 'SEK - Swedish Krona', value: 'SEK', symbol: 'kr' },
  { label: 'DKK - Danish Krone', value: 'DKK', symbol: 'kr' },
  { label: 'NOK - Norwegian Krone', value: 'NOK', symbol: 'kr' },
  { label: 'NZD - New Zealand Dollar', value: 'NZD', symbol: '$' },
  { label: 'SGD - Singapore Dollar', value: 'SGD', symbol: '$' },
  { label: 'HKD - Hong Kong Dollar', value: 'HKD', symbol: '$' },
  { label: 'CZK - Czech Koruna', value: 'CZK', symbol: 'Kč' },
  { label: 'PLN - Polish Zloty', value: 'PLN', symbol: 'zł' },
  { label: 'UAH - Ukrainian Hryvnia', value: 'UAH', symbol: '₴' },
  { label: 'HUF - Hungarian Forint', value: 'HUF', symbol: 'Ft' },
  { label: 'RON - Romanian Leu', value: 'RON', symbol: 'lei' },
  { label: 'BGN - Bulgarian Lev', value: 'BGN', symbol: 'лв' },
  { label: 'HRK - Croatian Kuna', value: 'HRK', symbol: 'kn' },
  { label: 'INR - Indian Rupee', value: 'INR', symbol: '₹' },
  { label: 'KRW - South Korean Won', value: 'KRW', symbol: '₩' },
  { label: 'TWD - Taiwan Dollar', value: 'TWD', symbol: 'NT$' },
  { label: 'THB - Thai Baht', value: 'THB', symbol: '฿' },
  { label: 'VND - Vietnamese Dong', value: 'VND', symbol: '₫' },
  { label: 'MYR - Malaysian Ringgit', value: 'MYR', symbol: 'RM' },
  { label: 'PHP - Philippine Peso', value: 'PHP', symbol: '₱' },
  { label: 'BRL - Brazilian Real', value: 'BRL', symbol: 'R$' },
  { label: 'MXN - Mexican Peso', value: 'MXN', symbol: '$' },
  { label: 'ARS - Argentine Peso', value: 'ARS', symbol: '$' },
  { label: 'CLP - Chilean Peso', value: 'CLP', symbol: '$' },
  { label: 'COP - Colombian Peso', value: 'COP', symbol: '$' },
  { label: 'UYU - Uruguayan Peso', value: 'UYU', symbol: '$U' },
  { label: 'PEN - Peruvian Sol', value: 'PEN', symbol: 'S/' },
  { label: 'ZAR - South African Rand', value: 'ZAR', symbol: 'R' },
  { label: 'NGN - Nigerian Naira', value: 'NGN', symbol: '₦' },
  { label: 'EGP - Egyptian Pound', value: 'EGP', symbol: '£' },
  { label: 'KES - Kenyan Shilling', value: 'KES', symbol: 'KSh' },
  { label: 'GHS - Ghanaian Cedi', value: 'GHS', symbol: 'GH₵' },
  { label: 'AED - United Arab Emirates Dirham', value: 'AED', symbol: 'AED' },
  { label: 'SAR - Saudi Riyal', value: 'SAR', symbol: 'SAR' },
  { label: 'QAR - Qatari Riyal', value: 'QAR', symbol: 'QAR' },
  { label: 'KWD - Kuwaiti Dinar', value: 'KWD', symbol: 'KD' },
  { label: 'ILS - Israeli Shekel', value: 'ILS', symbol: '₪' },
  { label: 'TRY - Turkish Lira', value: 'TRY', symbol: '₺' },
  { label: 'Choose currency', value: '...', symbol: '......' },
];

export default currencyData;
